import React from "react"
import { useConfirmation } from "../hooks/useConfirmation"
import { ConfirmCancelDialogue } from "./ConfirmCancelDialogue"
import { P } from "@cd2/text"

interface IProps {
  children: React.ReactNode
  heading: React.ReactNode
  body?: React.ReactNode
  className?: string
  disabled?: boolean

  onConfirm(): void
  onCancel?(): void
}

export function ConfirmOnClick({
  children,
  className,
  onConfirm,
  onCancel,
  heading,
  body,
  disabled,
}: IProps) {
  const [confirmNode, getConfirm] = useConfirmation(
    ({ onResolve }: { onResolve(value: boolean): void }) => (
      <ConfirmCancelDialogue
        heading={heading}
        body={
          body ? (
            <React.Fragment>{typeof body === "string" ? <P>{body}</P> : body}</React.Fragment>
          ) : undefined
        }
        onConfirm={() => onResolve(true)}
        onCancel={() => onResolve(false)}
        disabled={disabled}
        isOpen
      />
    ),
  )

  async function handleClick() {
    const shouldConfirm = await getConfirm({})
    if (shouldConfirm) {
      onConfirm()
    } else {
      onCancel?.()
    }
  }

  return (
    <div onClick={handleClick} className={className}>
      {confirmNode}
      {children}
    </div>
  )
}
